export var PlacesTabName;
(function (PlacesTabName) {
    PlacesTabName["BUDGETS"] = "budgets";
    PlacesTabName["LIST"] = "list";
    PlacesTabName["MAP"] = "map";
})(PlacesTabName || (PlacesTabName = {}));
